'use client';

import { easeInOut } from 'motion/react';

export const transition = { duration: 0.3, ease: easeInOut } as const;

export const reveal = (isInView: boolean) =>
  ({
    initial: { opacity: 0 },
    animate: isInView ? { opacity: 1 } : { opacity: 0 },
    transition: { opacity: { duration: 0.5, ease: easeInOut } },
  }) as const;

export const popUp = {
  initial: { y: -88, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: -88, opacity: 0 },
  transition,
} as const;
